import { Component } from 'react';
import { View } from 'react-native';
import { ActivityIndicator, Text } from 'trpc-react-native-ui';
import I18n from '../../../lib/i18n';
import RtlAwareStyleSheet from '../../../lib/rtl-aware-stylesheet';
import { getPlanFirstItem, getPlanRoamingItem, getPlanSecondItem } from '../../../lib/usage-formatters';
import theme from '../../../theme-config';

type Props = {
  subscription: Object,
  isLineOff: boolean,
};

class ShortPlan extends Component<Props> {

  //TODO move this logic to selector
  getSubscriptionItem(unitType) {
    const subscription = this.props.subscription;
    let subscriptionItem;
    const option = subscription.options.find(option => option.type === unitType);
    if (option) {
      subscriptionItem = option.characteristic?.value;
    } else {
      subscriptionItem = subscription.plan?.characteristics?.[unitType]?.value;
    }
    return subscriptionItem;
  }

  //TODO move this logic to selector
  getRoamingDataSubscriptionItem() {
    const subscription = this.props.subscription;
    let subscriptionItem;
    const option = subscription.options.find(option => /^ROA{1,2}\d_DATA$/.test(option.type));
    if (option) {
      subscriptionItem = option.characteristic?.value;
    } else {
      const characteristics = subscription.plan?.characteristics || {};
      const roamingKey = Object.keys(characteristics).find(key => /^ROA{1,2}\d_DATA$/.test(key));
      subscriptionItem = characteristics[roamingKey]?.value;
    }
    return subscriptionItem;
  }

  render() {
    const styles = getStyles();
    if (this.props.isLineOFF) {
      return (
        <View style={styles.container}>
          <Text style={[styles.planText, styles.lineOff]}>{I18n.t('Dashboard.Plan.shortPlanLineOff')}</Text>
        </View>
      );
    }
    if (!this.props.subscription.options || !this.props.subscription.plan) {
      return (
        <View style={styles.container}>
          <ActivityIndicator />
        </View>
      );
    }

    //TODO move this logic to selector
    const data = this.getSubscriptionItem('DATA');
    const voice = this.getSubscriptionItem('VOICE');
    const sms = this.getSubscriptionItem('SMS');
    const dataRoaming = this.getRoamingDataSubscriptionItem();
    const voiceRoaming = this.getSubscriptionItem('TO_ZONED_VOICE');
    /**********************************/

    const planFirstItem = getPlanFirstItem(data, voice, sms);
    const planSecondItem = getPlanSecondItem(data, voice, sms);
    const planRoamingItem = getPlanRoamingItem(dataRoaming, voiceRoaming);

    return (
      <View style={styles.container}>
        {!!planFirstItem && <Text style={styles.planText}>{planFirstItem}</Text>}
        {!!planSecondItem && <Text style={styles.planText}>{planSecondItem}</Text>}
        {planRoamingItem && (
          <>
            <Text style={styles.planTextRoaming}>{I18n.t('Dashboard.Plan.roamingShortValueTitle')}</Text>
            <Text style={styles.planTextRoaming}>{planRoamingItem}</Text>
          </>
        )}
      </View>
    );
  }
}

function getStyles() {
  return RtlAwareStyleSheet.create({
    container: {
      alignItems: 'center',
      flex: 1,
      justifyContent: 'center',
      padding: 7,
    },
    planText: {
      color: theme.secondaryColor,
      fontSize: 25,
      fontWeight: '600',
      marginRight: 3,
      textAlign: 'center',
    },
    planTextRoaming: {
      color: theme.secondaryColor,
      fontSize: 15,
      fontWeight: '600',
      marginRight: 3,
      textAlign: 'center',
    },
    lineOff: {
      color: theme.modeOffNoSubscription,
    },
  });
}

export default ShortPlan;
